import React from 'react';
import { SegmentedToggle } from '../../ui';
import { CALORIES_MODE } from '../../../utils/calories';

const MODE_OPTIONS = [
  { value: CALORIES_MODE.ADD, label: 'Add' },
  { value: CALORIES_MODE.REPLACE, label: 'Replace' },
];

// `caloriesmode` is an integer on the wire, and SegmentedToggle compares with
// `===`, so a value loaded as the string "1" would render neither side active.
const CaloriesModeToggle = ({ value, onChange, className = '' }) => (
  <SegmentedToggle
    size="sm"
    ariaLabel="Calories calculation"
    value={
      Number(value) === CALORIES_MODE.REPLACE
        ? CALORIES_MODE.REPLACE
        : CALORIES_MODE.ADD
    }
    onChange={onChange}
    options={MODE_OPTIONS}
    className={className}
  />
);

export default CaloriesModeToggle;
